gsap.registerPlugin(ScrollTrigger);

import { inView } from "vendor";
import { matchesMediaQuery } from "theme";

ScrollTrigger.config({
	ignoreMobileResize: true
});

const _lazyVideoObserve = () => {
	let lazyVideos = Array.from(document.querySelectorAll('video.lazyVideo'));

	lazyVideos.forEach(function(video) {
	    let observer = inView(video, (video) => {
			for (let source in video.target.children) {
				let videoSource = video.target.children[source];
				if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
					videoSource.src = videoSource.dataset.src;
				}
			}
			video.target.load();
			video.target.classList.remove("lazyVideo");
			
			return () => {
				
			};
			
		}, { 
			margin: "100px"
		});
		
	});
}

const _createAnimatedElementAnimation = (item, timeline, positionIn, positionOut, animationDuration, timelineDuration, disableTransitionOut = false, animationConfig, parallaxMovement = 0) => {

	let transitionInStart = {},
		transitionInEnd = {},
		transitionOutStart = {},
		transitionOutEnd = {},
		animationInActive = false,
		animationOutActive = false,
		animationParallaxActive = false;

	if (animationConfig['fade_in'] > 0) {
		transitionInStart.opacity = matchesMediaQuery("sm-max") ? 0.15 : 0;
		transitionInEnd.opacity = 1;
		animationInActive = true;
	}

	if (animationConfig['blur_in'] > 0 && !matchesMediaQuery("sm-max")) {
		transitionInStart.blur = 20;
		transitionInEnd.blur = 0;
		animationInActive = true;
	}

	if (animationConfig['fade_out'] > 0 && !disableTransitionOut) {
		transitionOutStart.opacity = 1;
		transitionOutEnd.opacity = matchesMediaQuery("sm-max") ? 0.15 : 0;
		animationOutActive = true;
	}

	if (animationConfig['blur_out'] > 0 && !disableTransitionOut && !matchesMediaQuery("sm-max")) {
		transitionOutStart.blur = 0;
		transitionOutEnd.blur = 20;
		animationOutActive = true;
	}

	if (animationConfig['parallaxSpeed'] != 0 && !matchesMediaQuery("sm-max")) {
		animationParallaxActive = true;
	}

	if (animationInActive || animationOutActive || animationParallaxActive) {
		if (animationInActive) {
			transitionInEnd.duration = animationDuration;
			transitionInEnd.ease = 'none';
			timeline.fromTo(
				item, 
				transitionInStart,
				transitionInEnd,
				positionIn
			);
		}

		if (animationOutActive) {
			transitionOutEnd.duration = animationDuration;
			transitionOutEnd.ease = 'none';
			timeline.fromTo(
				item, 
				transitionOutStart,
				transitionOutEnd,
				positionOut
			);
		}

		if (animationInActive) {
			gsap.set(
				item, 
				transitionInStart
			);
		}

		if (animationParallaxActive) {
			timeline.fromTo(
				item, 
				{
					y: (animationConfig['parallaxSpeed'] * parallaxMovement) + 'px'
				},
				{
					y: (animationConfig['parallaxSpeed'] * (parallaxMovement * -1)) + 'px',
					ease: 'none',
					duration: timeline.totalDuration()
				},
				0
			);
		}
	}
}

(function() {
	const 	blurProperty = gsap.utils.checkPrefix("filter"),
			blurExp = /blur\((.+)?px\)/,
  		    getBlurMatch = target => (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

	gsap.registerPlugin({
		name: "blur",
		get(target) {
			return +(getBlurMatch(target)[1]) || 0;
		},
		init(target, endValue) {
			var data = this,
				filter = gsap.getProperty(target, blurProperty),
				endBlur = "blur(" + endValue + "px)",
				match = getBlurMatch(target)[0],
				index;
			if (filter === "none") {
				filter = "";
			}
			if (match) {
				index = filter.indexOf(match);
				endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
			} else {
				endValue = filter + endBlur;
				filter += filter ? " blur(0px)" : "blur(0px)";
			}
			data.target = target; 
			data.interp = gsap.utils.interpolate(filter, endValue); 
		},
		render(progress, data) {
			data.target.style[blurProperty] = data.interp(progress);
		}
	});
})();

if (!CSS.supports('selector(:has(*))')) {
	if (document.querySelector('.shopify-section:first-child [allow-transparent-header]') && !document.querySelector('.shopify-section--header + .shopify-section-group-header-group')) {
		document.body.classList.add('poly-fill-allow-transparent-header');
	}
	Array.from(document.querySelectorAll('[sticky]')).forEach(function(item) {
		item.parentElement.classList.add('poly-fill-sticky');
	});
	Array.from(document.querySelectorAll('[overlay-next-section]')).forEach(function(item) {
		item.parentElement.classList.add('poly-fill-overlay-next-section');
	});
}

if (!CSS.supports('height: 100lvh')) {
	document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
}

_lazyVideoObserve();




var BlogPosts = class extends HTMLElement {
  constructor() {
    super();
  }
}

var BlogPostsGHD = class extends HTMLElement {
  constructor() {
    super();
  }
}

var LineItem = class extends HTMLElement {
  constructor() {
    super();
  }
}

var StickyInfoBar = class extends HTMLElement {
  constructor() {
    super();
  }
}

var PriceList = class extends HTMLElement {
  constructor() {
    super();
  }
}
window.customElements.define("blog-posts", BlogPosts);
window.customElements.define("blog-posts-ghd", BlogPostsGHD);
window.customElements.define("line-item", LineItem);
window.customElements.define("sticky-info-bar", StickyInfoBar);
window.customElements.define("price-list", PriceList);

let undefinedCustomElements = [],
	customElements = Array.from(document.querySelectorAll(':not(:defined)'));

customElements.forEach(function(item) {
	if (item.tagName.includes("-")) {
		undefinedCustomElements.push(item);
	}
});

let promises = [...undefinedCustomElements].map((item) => {
	return window.customElements.whenDefined(item.localName);
});

Promise.all(promises).then(() => {
	if (document.querySelectorAll('.animateQuick').length) {
		gsap.set(".animateQuick", {
			y: 80
		});
		
		if (matchesMediaQuery("sm-max")) {
			ScrollTrigger.batch(".animateQuick", {
				onEnter: batch => gsap.to(batch, {
					opacity: 1,
					y: 0,
					stagger: {
						each: 0.1
					},
					overwrite: true
				}),
				onLeave: batch => gsap.set(batch, {
					opacity: 0,
					y: -80,
					overwrite: true
				}),
				onEnterBack: batch => gsap.to(batch, {
					opacity: 1,
					y: 0,
					stagger: 0.1,
					overwrite: true
				}),
				onLeaveBack: batch => gsap.set(batch, {
					opacity: 0,
					y: 80,
					overwrite: true
				})
			});
		} else {
			ScrollTrigger.batch(".animateQuick", {
				onEnter: batch => gsap.to(batch, {
					opacity: 1,
					blur: 0,
					y: 0,
					stagger: {
						each: 0.1
					},
					overwrite: true
				}),
				onLeave: batch => gsap.set(batch, {
					opacity: 0,
					blur: 20,
					y: -80,
					overwrite: true
				}),
				onEnterBack: batch => gsap.to(batch, {
					opacity: 1,
					blur: 0,
					y: 0,
					stagger: 0.1,
					overwrite: true
				}),
				onLeaveBack: batch => gsap.set(batch, {
					opacity: 0,
					blur: 20,
					y: 80,
					overwrite: true
				})
			});
		}
		

		ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".animateQuick", {
			y: 0
		}));
	}
	
    document.documentElement.dispatchEvent(new CustomEvent("sections:activated", { bubbles: true }));
	
});



export {
	_lazyVideoObserve,
	_createAnimatedElementAnimation
};

